import React from 'react'
import PortalKebabMenu from './PortalKebabMenu'
import { isTimelineEndDatePassed } from '../../../utils/timelineAssetDates'
import {
  actionAccentColorFor,
  actionProviderFor,
  providerAccentColors,
  TimelineActionLabel,
  TimelineActionProviderIcon,
} from './timelineActionDisplay'

export default function ScenarioTimelineAssetItem({ timelineAsset, isTemporary, menuItems }) {
  const provider = actionProviderFor(timelineAsset)
  const isPassed = isTimelineEndDatePassed(timelineAsset.end_date)
  const accentColor = actionAccentColorFor(timelineAsset)
  const providerColor = providerAccentColors[provider] || accentColor
  const hasMenu = menuItems?.length > 0

  return (
    <div
      className={`
        flex h-full w-full items-center overflow-hidden rounded-md border-l-2 px-2 py-1
        text-left
        ${hasMenu ? 'justify-between' : ''}
        ${isTemporary ? 'opacity-70' : ''}
        ${
          isPassed
            ? 'bg-gray-100 opacity-75 shadow-none grayscale dark:bg-rb-dark-mode-lighter/60'
            : 'bg-white shadow-sm dark:bg-rb-dark-mode-lighter'
        }
      `}
      style={{
        left: 0,
        right: 0,
        zIndex: 1,
        minWidth: 0,
        borderLeftColor: accentColor,
      }}
    >
      <div className="flex min-w-0 flex-1 items-center gap-1">
        <TimelineActionProviderIcon
          asset={timelineAsset}
          className={`text-sm ${isPassed ? 'text-rb-lighter-grey dark:text-gray-400' : ''}`}
          style={isPassed ? { color: '#9ca3af' } : { color: providerColor }}
        />
        <TimelineActionLabel
          asset={timelineAsset}
          passed={isPassed}
          className={`text-xs font-medium ${
            isPassed
              ? 'text-rb-lighter-grey dark:text-gray-400'
              : 'text-rb-black dark:text-white'
          }`}
        />
      </div>
      {hasMenu && (
        <PortalKebabMenu
          items={menuItems}
          ariaLabel="Open timeline asset menu"
          buttonClassName="ml-1 rounded p-0.5 text-rb-black hover:bg-gray-100 dark:text-white dark:hover:bg-rb-dark-mode"
        />
      )}
    </div>
  )
}
